export const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_leads-automation-3/artifacts/s4t5o33s_CREREA.jpg";
